var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lAndG",class:{initMsgOpen: _vm.isinitialMessageOpen},attrs:{"id":"app"}},[_c('InitialMessage'),_c('Sidebar'),_c('Filters'),_c('Map')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }